<template lang="pug">
.campaign-tab
  el-tabs(
    v-model="activeName"
    @tab-click="handleClick"
  )
    el-tab-pane.campaign-tab__item(
      v-for="(item,i) of tabs"
      :key="i"
      :name="item"
      :disabled="item === '服务器类项目'"
    )
      span(slot="label") {{ $t(item)  }}
        span.tab__count(v-if="tabCount.length !== 0") {{ tabCount[i] }}
</template>

<script>
export default {
  // @emit: change(index)
  props: {
    tabs: {
      type: Array,
      default () {
        return []
      },
      required: true
    },
    index: {
      type: Number,
      default () {
        return 0
      }
    },
    tabCount: {
      type: Array,
      default () {
        return []
      }
    }
  },
  watch: {
    index () {
      this.activeName = this.tabs[this.index]
    },
    tabs () {
      this.activeName = this.tabs[this.index]
    }
  },
  data () {
    return {
      activeName: this.tabs[this.index]
    }
  },
  methods: {
    handleClick (tab) {
      this.$emit('change', Number(tab.index))
    }
  }
}
</script>

<style lang="stylus">
.campaign-tab
  .el-tabs__header
    margin 0
  .el-tabs__item
    min-width 116px !important
    text-align center
    line-height 22px
    height 22px
    margin-bottom 6px
    overflow hidden
    text-overflow ellipsis
    font-weight bold
  .el-tabs__active-bar
    min-width  96px !important
</style>
